import { jsx as _jsx } from "react/jsx-runtime";
import { Info } from "@air/next-icons";
import { Tooltip } from "@air/primitive-tooltip";
import { memo } from "react";
export const PermissionToggleInfo = /*#__PURE__*/ memo((param)=>{
    let { text } = param;
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: text,
        children: /*#__PURE__*/ _jsx(Info, {
            className: "size-4 text-grey-10"
        })
    });
});
PermissionToggleInfo.displayName = "PermissionToggleInfo";
